import api from "../../../../services/api";

const getSignature = () => localStorage.getItem("signature");

const post = async (path: string, body: Record<string, any>) => {
  const response = await api.post(path, {
    signature: getSignature(),
    ...body,
  });
  return response.data?.data;
};

export const createLink = async (
  companyId: string,
  companyType: string,
  payload: {
    source_issue_id: number;
    target_issue_id: number;
    link_type: string;
  }
) =>
  post("projectService/issueLink/createLink", {
    company_id: companyId,
    company_type: companyType,
    ...payload,
  });

export const deleteLink = async (
  companyId: string,
  companyType: string,
  id: number
) =>
  post("projectService/issueLink/deleteLink", {
    company_id: companyId,
    company_type: companyType,
    id,
  });

export const listByIssue = async (
  companyId: string,
  companyType: string,
  issueId: number
) =>
  post("projectService/issueLink/listByIssue", {
    company_id: companyId,
    company_type: companyType,
    issue_id: issueId,
  });
